<template>
  <input type="button" class="button" @click="$emit('click')" value="✕" />
</template>

<script>
export default {

}
</script>

<style scoped>
.button {
  color: white;
  font-size: 15px;
  height: 26px;
  width: 26px;
}

</style>